import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import './Hero.css';

export default function Hero() {
  const { data } = useData();
  const company = data?.company || {};
  const stats = data?.stats || [];

  return (
    <section className="hero">
      <div className="container">
        <div className="hero__content">
          <h1 className="hero__title">
            Build the Future<br />
            <span className="hero__title-accent">With IWX</span>
          </h1>
          <p className="hero__subtitle">{company.description}</p>
          <div className="hero__actions">
            <Link to="/products" className="btn btn--primary btn--lg">Explore Products</Link>
            <Link to="/contact" className="btn btn--outline btn--lg">Get In Touch</Link>
          </div>
          <div className="hero__stats">
            {stats.map(stat => (
              <div key={stat.id} className="hero__stat">
                <span className="hero__stat-value">{stat.value}</span>
                <span className="hero__stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
